
	import {
		message
	} from 'ant-design-vue';
	import {
		defineComponent,
		onMounted,
		ref,
		reactive
	} from 'vue';
	import {
		MinusCircleOutlined,
		PlusOutlined
	} from '@ant-design/icons-vue';
	import subjectList from '@/assets/data/subject.json';
	import studyPhaseList from '@/assets/data/studyPhase.json';
	import infotask from '@/service/infotask'
	import dayjs from 'dayjs';

	export default defineComponent({
		components: {
			MinusCircleOutlined,
			PlusOutlined
		},
		setup(props, context) {
			// 声明
			const dateFormat = 'YYYY-MM-DD HH:mm';
			let visible = ref(false);
			const labelCol = {
				xs: {
					span: 8
				},
				sm: {
					span: 6
				},
				xl: {
					span: 4
				},
				xxl: {
					span: 3
				}
			};
			const wrapperCol = {
				xs: {
					span: 14
				},
				sm: {
					span: 18
				},
				xl: {
					span: 14
				},
				xxl: {
					span: 10
				}
			};
			let formState = reactive({
				taskName: '',
				applyTime: [],
				applyStartTime: '',
				applyEndTime: '',
				reviewTime: [],
				reviewStartTime: '',
				reviewEndTime: '',
				arbitrateTime: [],
				arbitrateStartTime: '',
				arbitrateEndTime: '',
				arbitrateScore: '',
				ifLogin: '1',
				opinionWordsNumber: '1',
				reviewLevel: '2',
				ifTqjsReview: '1',
				ifTxkjsReview: '1',
				ifTxdjsReview: '1',
				subjectScope: [],
				studyPhase: [],
				introduction: ''
			});
			let uploadForm = reactive({
				dataList: [],
			});
			let status = ref("")
			let statusShow = ref(false)
			let statusShow1 = ref([false,false])
			let statusShow2 = ref([false,false])
			let statusShow3 = ref([false,false])
			// 页面渲染时加载
			onMounted(() => {})
			// 打开页面
			const open = (e) => {
				status.value = e.status
				// 0待开始 1报名中 2分配评审 3评审中 4分配仲裁评审 5仲裁评审中 6已结束
				if(e.status=="0"){ // 待开始状态 所有内容可以修改
					statusShow.value = false 
					statusShow1.value = [false,false] 
					statusShow2.value = [false,false] 
					statusShow3.value = [false,false] 
				}else if(e.status=="1"||e.status=="2"){ //报名中，分配评审状态，报名结束及后续时间可以修改
					statusShow.value = true
					statusShow1.value = [true,false] 
					statusShow2.value = [false,false] 
					statusShow3.value = [false,false]
				}else if(e.status=="3"||e.status=="4"){ //评审中状态，分配仲裁评审，评审结束及后续时间可以修改
					statusShow.value = true
					statusShow1.value = true
					statusShow2.value = [true,false] 
					statusShow3.value = [false,false] 
				}else if(e.status=="5"){ //仲裁评审中状态，仲裁评审结束时间可以修改
					statusShow.value = true
					statusShow1.value = true
					statusShow2.value = true
					statusShow3.value = [true,false] 
				}else{
					statusShow.value = true
					statusShow1.value = true
					statusShow2.value = true
					statusShow3.value = true
				}

				if (e) {
					formState.id = e.id;
					infotask.getActivity(e.id).then(({
						data
					}) => {
						if (data.code == '0') {
							formState.taskName = data.data.taskName;
							formState.applyStartTime = data.data.applyStartTime;
							formState.applyEndTime = data.data.applyEndTime;
							formState.reviewStartTime = data.data.reviewStartTime;
							formState.reviewEndTime = data.data.reviewEndTime;
							formState.arbitrateStartTime = data.data.arbitrateStartTime;
							formState.arbitrateEndTime = data.data.arbitrateEndTime;
							formState.applyTime = [dayjs(data.data.applyStartTime, dateFormat), dayjs(data.data.applyEndTime, dateFormat)];
							formState.reviewTime = [dayjs(data.data.reviewStartTime, dateFormat),dayjs(data.data.reviewEndTime, dateFormat)];
							formState.arbitrateTime = [dayjs(data.data.arbitrateStartTime, dateFormat),dayjs(data.data.arbitrateEndTime, dateFormat)];
							formState.introduction = data.data.introduction;
							formState.arbitrateScore = data.data.arbitrateScore;
							formState.opinionWordsNumber = data.data.opinionWordsNumber;
							formState.ifLogin = data.data.ifLogin;
							formState.reviewLevel = data.data.reviewLevel;
							formState.ifTqjsReview = data.data.ifTqjsReview;
							formState.ifTxkjsReview = data.data.ifTxkjsReview;
							formState.ifTxdjsReview = data.data.ifTxdjsReview;
							formState.subjectScope = data.data.subjectScope.split(",");
							formState.studyPhase = data.data.studyPhase.split(",");
							let uploadSet = new Array
							uploadSet = JSON.parse(data.data.uploadSet).uploadSet
							uploadSet.map(item=>{
								if(item.ifMust == '1'){
									item.required = true
								}else{
									item.required = false
								}
								item.type = item.fileType
							})
							uploadForm.dataList = uploadSet
						} else {
							message.error(data.msg);
						}
					})
				}
				visible.value = true
			}
			// 提交表单
			const handleOk = () => {
				
				let newData =  new Date()
				let newTime = newData.getTime()
				let stime1 =new Date(formState.applyEndTime).getTime();
				let etime1 = new Date(formState.reviewStartTime).getTime();
				console.log(status.value)
				if(status.value == '0' || status.value == '1' || status.value == '2'){
					if(newTime>stime1){
						message.error('请设置报名结束时间大于当前系统时间');
						return
					}
				}

				let usedTime1 = (etime1 - stime1)/60000;  //两个时间戳相差的毫秒数
				if(usedTime1<1){
					message.error('评审开始时间 应大于 报名结束时间 1分钟以上');
					return
				}
				let stime2 =new Date(formState.reviewEndTime).getTime();
				let etime2 = new Date(formState.arbitrateStartTime).getTime();
				let usedTime2 = (etime2 - stime2)/60000;  //两个时间戳相差的毫秒数
				if(usedTime2<1){
					message.error('仲裁开始时间 应大于 评审结束时间 1分钟以上');
					return
				}
				
				if (formState.taskName == '') {
					message.error('请输入活动名称');
					return;
				}
				if (formState.taskName == '') {
					message.error('请输入活动名称');
					return;
				}
				if (formState.applyTime == '') {
					message.error('请选择报名时间');
					return;
				}
				
				if (formState.reviewTime == '') {
					message.error('请选择评审时间');
					return;
				}
				if (formState.arbitrateTime == '') {
					message.error('请选择仲裁评审时间');
					return;
				}
				if (formState.arbitrateScore == '') {
					message.error('请输入仲裁分值设置');
					return;
				}
				if (formState.opinionWordsNumber == '') {
					message.error('请输入评审意见字数设置');
					return;
				}
				if (formState.ifLogin == '') {
					message.error('请选择是否需要登陆报名');
					return;
				}
				if (formState.reviewLevel == '') {
					message.error('请选择活动评审机制级别');
					return;
				}
				if (formState.ifTqjsReview == '') {
					message.error('请选择是否允许同区教师评审');
					return;
				}
				if (formState.ifTxkjsReview == '') {
					message.error('请选择是否允许同学科教师评审');
					return;
				}
				if (formState.ifTxdjsReview == '') {
					message.error('请选择是否允许同学段教师评审');
					return;
				}
				if (formState.subjectScope.length == 0) {
					message.error('请选择学科范围');
					return;
				}
				if (formState.studyPhase.length == 0) {
					message.error('请选择学段范围');
					return;
				}
				if (uploadForm.dataList.length == 0) {
					message.error('请添加上传设置');
					return;
				}
				let uploadSets = {
					uploadSet: []
				};
				uploadForm.dataList.map(item => {
					let ifMust = item.required == true ? '1' : '0';
					uploadSets.uploadSet.push({
						ifMust: ifMust,
						fileType: item.type
					})
				})
				if (uploadSets.uploadSet.length == 0) {
					message.error('请填写上传说明');
					return;
				}
				let dataJson = {
					id: formState.id,
					schoolCode: sessionStorage.getItem('schoolCode'),
					taskName: formState.taskName,
					applyStartTime: formState.applyStartTime,
					applyEndTime: formState.applyEndTime,
					reviewStartTime: formState.reviewStartTime,
					reviewEndTime: formState.reviewEndTime,
					arbitrateStartTime: formState.arbitrateStartTime,
					arbitrateEndTime: formState.arbitrateEndTime,
					arbitrateScore: formState.arbitrateScore,
					ifLogin: formState.ifLogin,
					opinionWordsNumber: formState.opinionWordsNumber,
					reviewLevel: formState.reviewLevel,
					ifTqjsReview: formState.ifTqjsReview,
					ifTxkjsReview: formState.ifTxkjsReview,
					ifTxdjsReview: formState.ifTxdjsReview,
					subjectScope: formState.subjectScope.toString(),
					studyPhase: formState.studyPhase.toString(),
					introduction: formState.introduction,
					uploadSet: JSON.stringify(uploadSets)
				}


				infotask.updateActivity(dataJson).then(({
					data
				}) => {
					if (data.code == '0') {
						message.success(data.msg);
						visible.value = false;
						context.emit('editRefresh', 'ok');
					} else {
						message.error(data.msg);
					}
				})
			}
			// 切换报名时间
			const changeTime1 = (date, dateString) => {
				console.log(date)
				formState.applyStartTime = dateString[0];
				formState.applyEndTime = dateString[1];
			}
			// 评审时间
			const changeTime3 = (date, dateString) => {
				console.log(date)
				formState.reviewStartTime = dateString[0];
				formState.reviewEndTime = dateString[1];
			}
			// 仲裁评审时间
			const changeTime4 = (date, dateString) => {
				console.log(date)
				formState.arbitrateStartTime = dateString[0];
				formState.arbitrateEndTime = dateString[1];
			}

			// 添加 上传设置
			const addUser = () => {
				uploadForm.dataList.push({
					required: true,
					type: 'pdf',
					id: Date.now(),
				});
			};
			// 移除添加的 上传设置
			const removeUser = item => {
				let index = uploadForm.dataList.indexOf(item);
				if (index !== -1) {
					uploadForm.dataList.splice(index, 1);
				}
			};
			
			// 重置表单
			const setForm = () => {
				formState.taskName = '';
				formState.applyTime = [];
				formState.applyStartTime = '';
				formState.applyEndTime = '';
				formState.reviewTime = [];
				formState.reviewStartTime = '';
				formState.reviewEndTime = '';
				formState.arbitrateTime = [];
				formState.arbitrateStartTime = '';
				formState.arbitrateEndTime = '';
				formState.arbitrateScore = '';
				formState.ifLogin = '1';
				formState.opinionWordsNumber = '1';
				formState.reviewLevel = '2';
				formState.ifTqjsReview = '1';
				formState.ifTxkjsReview = '1';
				formState.ifTxdjsReview = '1';
				formState.subjectScope = [];
				formState.studyPhase = [];
				formState.introduction = '';
			}

			return {
				visible,
				open,
				handleOk,
				formState,
				changeTime1,
				changeTime3,
				changeTime4,
				labelCol,
				wrapperCol,
				dateFormat,
				subjectList,
				studyPhaseList,
				addUser,
				removeUser,
				setForm,
				uploadForm,
				status,
				statusShow,
				statusShow1,
				statusShow2,
				statusShow3,
				
			
			};
		},

	});
